import { render, staticRenderFns } from "./BoxWithIcon.vue?vue&type=template&id=270f1bdc&"
import script from "./BoxWithIcon.vue?vue&type=script&lang=js&"
export * from "./BoxWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports